import React from 'react';
import cs from 'classnames';

import './field-group.css';

const FieldGroup = ({ field, children }) => {
	const { touched, error } = field.meta;
	const fieldClass = cs("field-group", {"field-group--has-error": touched && error});

	return (
		<div className={fieldClass}>
			{field.label && <label className="field-group__label">{field.label}</label>}
			{children}
			{touched && error && <span className="field-group__error">{error}</span>}
		</div>
	);
};

export default FieldGroup;


// WEBPACK FOOTER //
// ./src/components/common/form/FieldGroup/index.js